import { constructSafeRedirect } from './redirects';

function isDefinedGuard<T>(x: T | undefined): x is T {
  return !!x;
}

export { isDefinedGuard, constructSafeRedirect };
